import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="animate-fadeIn" data-testid="privacy-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <h1 className="font-serif text-4xl md:text-5xl text-text-primary mb-8">
          Privacy Policy
        </h1>
        
        <div className="prose prose-sage max-w-none space-y-8">
          <p className="text-text-secondary text-lg leading-relaxed">
            Last Updated: January 2026
          </p>

          <p className="text-text-secondary leading-relaxed">
            Live Life Global Wellness ("we," "us," or "our") is committed to protecting your privacy. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
            when you visit our website and use our services.
          </p>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              1. Information We Collect
            </h2>
            <h3 className="font-medium text-text-primary mt-4 mb-2">Personal Information</h3>
            <p className="text-text-secondary leading-relaxed">
              We may collect personal information that you voluntarily provide when you:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-text-secondary">
              <li>Create an account</li>
              <li>Make a purchase</li>
              <li>Subscribe to our newsletter</li>
              <li>Contact us with inquiries</li>
            </ul>
            <p className="text-text-secondary leading-relaxed mt-4">
              This information may include your name, email address, mailing address, phone number, 
              and payment information.
            </p>

            <h3 className="font-medium text-text-primary mt-6 mb-2">Automatically Collected Information</h3>
            <p className="text-text-secondary leading-relaxed">
              When you access our website, we may automatically collect certain information, including:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-text-secondary">
              <li>Device and browser type</li>
              <li>IP address</li>
              <li>Pages visited and time spent</li>
              <li>Referring website</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              2. How We Use Your Information
            </h2>
            <p className="text-text-secondary leading-relaxed">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-text-secondary">
              <li>Process and fulfill your orders</li>
              <li>Send you order confirmations and updates</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Send promotional communications (with your consent)</li>
              <li>Improve our website and services</li>
              <li>Prevent fraud and ensure security</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              3. Information Sharing
            </h2>
            <p className="text-text-secondary leading-relaxed">
              We do not sell, trade, or rent your personal information to third parties. 
              We may share your information with:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-text-secondary">
              <li>Service providers who assist with order fulfillment and shipping</li>
              <li>Payment processors for secure transaction handling</li>
              <li>Analytics providers to help us understand website usage</li>
              <li>Law enforcement when required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              4. Data Security
            </h2>
            <p className="text-text-secondary leading-relaxed">
              We implement appropriate technical and organizational security measures to protect 
              your personal information. However, no method of transmission over the Internet or 
              electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              5. Your Rights
            </h2>
            <p className="text-text-secondary leading-relaxed">
              Depending on your location, you may have the right to:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-text-secondary">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt out of marketing communications</li>
              <li>Lodge a complaint with a supervisory authority</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              6. Cookies
            </h2>
            <p className="text-text-secondary leading-relaxed">
              We use cookies and similar tracking technologies to enhance your experience on our website. 
              You can control cookie settings through your browser preferences.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              7. Third-Party Links
            </h2>
            <p className="text-text-secondary leading-relaxed">
              Our website may contain links to third-party websites, including Circulate Travel 
              for Wellness Trips. We are not responsible for the privacy practices of these 
              external sites. We encourage you to review their privacy policies before 
              providing any personal information.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              8. Children's Privacy
            </h2>
            <p className="text-text-secondary leading-relaxed">
              Our website is not intended for children under 18 years of age. We do not knowingly 
              collect personal information from children under 18.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              9. Changes to This Policy
            </h2>
            <p className="text-text-secondary leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of any 
              changes by posting the new Privacy Policy on this page and updating the 
              "Last Updated" date.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-text-primary mt-8 mb-4">
              10. Contact Us
            </h2>
            <p className="text-text-secondary leading-relaxed">
              If you have questions or concerns about this Privacy Policy, please contact us at:
            </p>
            <p className="text-text-secondary mt-4">
              <strong>Email:</strong> hello@livelifeglobal.com<br />
              <strong>Phone:</strong> 1-800-WELLNESS
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
